var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isScheduled || _vm.$store.state.isAdminView
    ? _c(
        "div",
        {
          staticClass: "menu--item menu--item-text_only",
          class: { "menu--item-highlighted": _vm.item.mi_highlight === 1 },
          attrs: {
            "data-menu-item-id": _vm.item.mi_id,
            id: "menu--item-" + _vm.item.mi_id,
          },
        },
        [
          _c("p", {
            staticClass: "menu--item_description",
            domProps: {
              innerHTML: _vm._s(_vm.item.mi_description || _vm.item.mi_title),
            },
          }),
          _vm._v(" "),
          _vm.$store.state.isAdminView && _vm.item.normalizedSchedules.length
            ? _c("menu-schedules", {
                attrs: { "normalized-schedules": _vm.item.normalizedSchedules },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }